export default __webpack_public_path__ + "static/media/button_placement__fill_form.d1939779.png";